import { Image, Typography } from "antd";
import MOCKUP from "../assets/building.jpg";
// import HUMAN from "../assets/human_image.png";
import { useEffect, useState } from "react";

const convertToActualSize = (value, unit) => {
  if (unit === "feet") return parseFloat(value) / 12;
  if (unit === "meter") return parseFloat(value) / 1000;
  return parseFloat(value);
};

const DesiredMockup = ({
  wallWidth,
  wallHeight,
  unit,
  drawer,
  selectedModelData,
  column,
  row,
  useImage,
  setDimensions,
  dimensions,
}) => {
  // const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const paddingOverall = 0;
  const doublePadding = paddingOverall * 2;
  const textMargin = 2;

  const imgwidth =
    unit === "meter"
      ? selectedModelData.panelDimensions.metric[0].width
      : selectedModelData.panelDimensions.imperial[0].width;
  const imgheight =
    unit === "meter"
      ? selectedModelData.panelDimensions.metric[0].height
      : selectedModelData.panelDimensions.imperial[0].height;

  const innerWidthSize = window.innerWidth;
  const innerHeightSize = window.innerHeight;
  const finalBox =
    innerHeightSize > innerWidthSize
      ? innerWidthSize - 150
      : innerHeightSize - 150;

  useEffect(() => {
    const updateSize = () => {
      const scaleX = finalBox / wallWidth;
      const scaleY = finalBox / wallHeight;
      const scale = Math.min(scaleX, scaleY);

      setDimensions({
        width: wallWidth * scale,
        height: wallHeight * scale,
        scale,
      });
    };

    updateSize();

    window.addEventListener("resize", updateSize);

    return () => window.removeEventListener("resize", updateSize);
  }, [wallWidth, wallHeight]);

  const imageWidthMeters = convertToActualSize(imgwidth, unit);
  const imageHeightMeters = convertToActualSize(imgheight, unit);
  const imageWidthPx = imageWidthMeters * dimensions.scale;
  const imageHeightPx = imageHeightMeters * dimensions.scale;

  //TEXT GUIDE
  const first1GuideWidth = imageWidthMeters * column;
  const first1GuideHeight = imageHeightMeters * row;
  const first2GuideWidth = wallWidth - first1GuideWidth;
  const first2GuideHeight = wallHeight - first1GuideHeight;
  const first3GuideWidth = first2GuideWidth / 2;
  const first3GuideHeight = first2GuideHeight / 2;
  const second1GuideWidth = imageWidthMeters * column;
  const second1GuideHeight = imageHeightMeters * row;

  //DIVISION DASH GUIDE
  const calc1Width = imageWidthPx * column;
  const calc1Height = imageHeightPx * row;
  const calc2Width = dimensions.width - calc1Width;
  const calc2Height = dimensions.height - calc1Height;
  const calc3Width = calc2Width / 2;
  const calc3Height = calc2Height / 2;

  return (
    <div
      style={{
        // paddingTop: 30,
        // paddingBottom: 30,
        // paddingLeft: 105,
        // paddingRight: 105,
        padding: 30,
        backgroundColor: "#0f0f22",
        borderRadius: 20,
        // border: "1px solid red",
      }}
    >
      <div
        style={{
          width: dimensions.width,
          height: dimensions.height,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          // overflow: "auto",
          position: "relative",
          zIndex: 1,
          border: "1px dashed #444",
        }}
      >
        {useImage ? (
          <Image
            src={MOCKUP}
            preview={false}
            alt="mockup"
            style={{
              width: calc1Width,
              height: calc1Height,
              zIndex: 2,
              padding: paddingOverall,
            }}
          />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: imageWidthPx * column,
              height: imageHeightPx * row,
              // border: "1px solid red",
            }}
          >
            {Array.from({ length: row }).map((_, index) => (
              <div
                key={index}
                style={{ display: "flex", flexDirection: "row-reverse" }}
              >
                {Array.from({ length: column }).map((_, index2) => {
                  return (
                    <div
                      key={index2}
                      style={{
                        width: imageWidthPx - doublePadding / column,
                        height: imageHeightPx - doublePadding / row,
                        background: "linear-gradient(210deg, #5252bb, #1f1f66)",
                        border: "1px solid #0c0c1c",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: 12,
                          color: "#fff",
                          // fontSize:
                          // wallWidth >= 13
                          //   ? 5
                          //   : wallWidth >= 10
                          //   ? 7
                          //   : wallWidth >= 5
                          //   ? 9
                          //   : 12,
                        }}
                      >
                        {index + 1}-{index2 + 1}
                      </Typography>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        )}

        {/* GOODS */}
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            borderLeft: "1px dashed #FFF",
            borderBottom: "1px dashed #FFF",
            width: calc3Width + paddingOverall,
            height: calc3Height + paddingOverall,
          }}
        >
          <div
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              height: "100%",
              justifyContent: "space-between",
            }}
          >
            {/* <Typography
              style={{
                color: "#fff",
                fontSize: 12,
                margin: textMargin,
              }}
            >
              {first3GuideWidth.toFixed(2)}
              {unit === "meter" ? "m" : "ft"}
            </Typography>
            <Typography
              style={{
                color: "#fff",
                textAlign: "end",
                fontSize: 12,
                marginRight: textMargin,
              }}
            >
              {first3GuideHeight.toFixed(2)}
              {unit === "meter" ? "m" : "ft"}
            </Typography> */}
          </div>
        </div>
        {/* GOODS */}
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            borderLeft: "1px dashed #FFF",
            borderBottom: "1px dashed #FFF",
            // border: "1px dashed red",
            width: calc3Width + calc1Width - paddingOverall,
            height: calc3Height + calc1Height - paddingOverall,
          }}
        >
          <div
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              height: "100%",
              justifyContent: "space-between",
            }}
          >
            <Typography
              style={{
                color: "#fff",
                fontSize: 12,
                position: "absolute",
                right: 0,
                marginRight:
                  (imageWidthPx * column) / 2 +
                  calc3Width +
                  paddingOverall -
                  17,
                backgroundColor: "#000",
                padding: 1,
                borderRadius: 4,
                maxWidth: 40,
                width: "100%",
                textAlign: "center",
              }}
            >
              {second1GuideWidth.toFixed(2)}
              {unit === "meter" ? "m" : "ft"}
            </Typography>
            <Typography
              style={{
                color: "#fff",
                fontSize: 12,
                position: "absolute",
                right: 0,
                marginTop:
                  (imageHeightPx * row) / 2 + calc3Height + paddingOverall - 10,
                backgroundColor: "#000",
                padding: 1,
                borderRadius: 4,
              }}
            >
              {second1GuideHeight.toFixed(2)}
              {unit === "meter" ? "m" : "ft"}
            </Typography>
          </div>
        </div>
        {/* GOODS */}
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            width: dimensions.width,
            height: dimensions.height,
          }}
        >
          <div
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              height: "100%",
              justifyContent: "space-between",
            }}
          >
            {/* <Typography
              style={{
                color: "#fff",
                fontSize: 12,
                margin: textMargin,
              }}
            >
              {first3GuideWidth.toFixed(2)}
              {unit === "meter" ? "m" : "ft"}
            </Typography>
            <Typography
              style={{
                color: "#fff",
                textAlign: "end",
                fontSize: 12,
                margin: textMargin,
              }}
            >
              {first3GuideHeight.toFixed(2)}
              {unit === "meter" ? "m" : "ft"}
            </Typography> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesiredMockup;
